function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));
  summary.nextElementSibling.getAttribute("id") && summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  summary.addEventListener("click", event => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });
  !summary.closest("header-drawer") && summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", event => {
    mouseClick = true;
  });

  window.addEventListener("focus", () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove("focused");
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add("focused");
  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach(video => video.pause());
  document.querySelectorAll("product-model").forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    const IncValue = this.input.value;
    var priceElement = document.querySelector(".product__info-container"),
      priceElementDIV = document.querySelector(".price-wrapper");
    if (!priceElementDIV) return;
    var currentPrice = priceElement.querySelector(".product-price-current"),
      SubPrice = currentPrice.dataset.price.replace(/[^0-9\.]/g, ""),
      ReultPrice = SubPrice.replace(/^(\.+)/g, ""),
      EvalPrice = parseInt(ReultPrice),
      subtotal = IncValue * EvalPrice,
      subtotalElement = document.getElementById("subtotal-value");
    subtotalElement && (subtotalElement.innerText = Shopify.formatMoney(subtotal + ".00", DT_THEME.moneyFormat));
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": `application/${type}` }
  };
}

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options.method || "post";
  var params = options.parameters || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options.hideElement || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach(summary => summary.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button:not(.localization-selector)").forEach(button => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach(details => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(submenu => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    elementToFocus && (super.closeMenuDrawer(event, elementToFocus), this.header.classList.remove("menu-open"), window.removeEventListener("resize", this.onResize));
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", event => {
      event.code.toUpperCase() === "ESCAPE" && this.hide();
    });
    this.classList.contains("media-modal") ? this.addEventListener("pointerup", event => {
      event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model") && this.hide();
    }) : this.addEventListener("click", event => {
      event.target === this && this.hide();
    });
  }

  connectedCallback() {
    this.moved || (this.moved = true, document.body.appendChild(this));
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    popup && popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    button && button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      modal && modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DetailsOverlayModal extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector('[role="dialog"]');
    this.closeButton = this.querySelector('.dT_TopStickySearchCloseBtn');
    this.overlay = this.querySelector('[data-search-modal-overlay]');
    this.trigger = document.getElementById('dT_TopStickySearchBtn');
    this.onTriggerClick = this.open.bind(this);
    this.onCloseClick = this.close.bind(this);
    this.onOverlayClick = this.close.bind(this);
    this.onKeyup = this.handleKeyup.bind(this);
  }

  connectedCallback() {
    this.trigger?.addEventListener('click', this.onTriggerClick);
    this.closeButton?.addEventListener('click', this.onCloseClick);
    this.overlay?.addEventListener('click', this.onOverlayClick);
    this.addEventListener('keyup', this.onKeyup);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTriggerClick);
    this.closeButton?.removeEventListener('click', this.onCloseClick);
    this.overlay?.removeEventListener('click', this.onOverlayClick);
    this.removeEventListener('keyup', this.onKeyup);
  }

  open(event) {
    event?.preventDefault();
    if (this.classList.contains('search-show')) return;

    this.openedBy = event?.currentTarget || this.trigger;
    this.classList.add('search-show');
    this.setAttribute('aria-hidden', 'false');
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('search-overlay-open');

    const input = this.querySelector('input[type="search"]');
    requestAnimationFrame(() => trapFocus(this.dialog, input || this.dialog));
  }

  close(event) {
    event?.preventDefault();
    if (!this.classList.contains('search-show')) return;

    this.querySelector('predictive-search')?.close(true);
    this.classList.remove('search-show');
    this.setAttribute('aria-hidden', 'true');
    this.trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('search-overlay-open');
    removeTrapFocus(this.openedBy || this.trigger);
  }

  handleKeyup(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    event.preventDefault();
    this.close();
  }
}

if (!customElements.get('details-overlay-modal')) {
  customElements.define('details-overlay-modal', DetailsOverlayModal);
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    poster && poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      focus && deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent("slideChanged", {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const predefine = {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {},
    };
    const slider_options = this.slider.getAttribute("data-slider-options");
    if (slider_options === null || slider_options === "") return null;

    const grouping = $.extend(true, predefine, JSON.parse(slider_options));
    const isNumberic = /^\d+$/;
    Object.keys(grouping).forEach(key => {
      if (typeof grouping[key] === "string" && isNumberic.test(grouping[key])) {
        grouping[key] = parseInt(grouping[key], 10);
      }
    });

    let autoplay = false;
    grouping.auto_play > 0 && (autoplay = { delay: grouping.auto_play * 1000 });

    let loop = false;
    (grouping.loop === "true" || grouping.loop === true) && (loop = true);

    const option = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop,
      autoplay,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true,
      },
      lazy: true,
      effect: grouping.effect,
    }, grouping.options);

    const container = this.slider.querySelector("[data-swiper-slider]");
    const initiate = new Swiper(container, option);

    initiate.on("init", () => {
      initiate.update();
    });
    initiate.init();
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.initLoad();
    this.addEventListener("change", this.onVariantChange);
  }

  initLoad() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput(); // Khởi tạo input variant ngay khi tải
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.toggleAddButton(!this.currentVariant, "", false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, "", true);
    }
    // [OPTIMIZED] Chỉ cập nhật nếu có thay đổi variant để giảm xung đột layout
    const variantInput = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
    if (this.currentVariant && variantInput && String(this.currentVariant.id) !== variantInput.value) {
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), select => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => !variant.options.map((option, index) => this.options[index] === option).includes(false));
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    document.getElementById(`MediaGallery-${this.dataset.section}`).setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    !this.currentVariant || this.dataset.updateUrl === "false" || window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    !shareButton || !shareButton.updateUrl || shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant ? this.currentVariant.id : "";
        input.dispatchEvent(new Event("change", { bubbles: true }));
        console.log("Variant ID updated to:", input.value); // Debug
      } else {
        console.error("Input [name='id'] not found in form:", productForm);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    pickUpAvailability && (this.currentVariant && this.currentVariant.available ? pickUpAvailability.fetchAvailability(this.currentVariant.id) : (pickUpAvailability.removeAttribute("available"), pickUpAvailability.innerHTML = ""));
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
    const productForm = section.querySelector("product-form");
    productForm && productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).then(response => response.text()).then(responseText => {
      const html = new DOMParser().parseFromString(responseText, "text/html"),
        qty = document.getElementById(`Quantity-template-${this.dataset.section}`),
        destination = document.getElementById(`price-${this.dataset.section}`),
        source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      source && destination && (destination.innerHTML = source.innerHTML);
      const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
        skuDestination = document.getElementById(`Sku-${this.dataset.section}`),
        inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
        inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
      skuSource && skuDestination && (skuDestination.innerHTML = skuSource.innerHTML, skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"))), inventorySource && inventoryDestination && (inventoryDestination.innerHTML = inventorySource.innerHTML);
      const price = document.getElementById(`price-${this.dataset.section}`);
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      const subTotal = document.getElementById(`subtotal-${this.dataset.section}`),
        destination2 = document.getElementById(`subtotal-${this.dataset.section}`),
        source2 = html.getElementById(`subtotal-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      source2 && destination2 && (destination2.innerHTML = source2.innerHTML), inventoryDestination && inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`),
      sku = document.getElementById(`Sku-${this.dataset.section}`),
      addButton = button.querySelector('[name="add"]'),
      addButtonText = button.querySelector('[name="add"] > span'),
      price = document.getElementById(`price-${this.dataset.section}`),
      inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    addButton && (addButtonText.textContent = window.variantStrings.unavailable, sku && sku.classList.add("visibility-hidden"));
  }

  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map(fieldset => Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked).value);
  }
}

customElements.define("variant-radios", VariantRadios);

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let s = false;
    t.auto_play > 0 && (s = {
      delay: 1000 * t.auto_play
    });
    let l = false,
      r = false;
    t.loop === "true" || t.loop === true ? l = true : t.loop === 1 ? (l = true, r = true) : (r = false, l = false);
    const o = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: l,
      preventClicks: true,
      preventClicksPropagation: true,
      autoplay: s,
      centeredSlides: r,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        560: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      a = new Swiper(n, o);
    a.on("init", () => {
      a.update();
    }), a.init();
  }
}

customElements.define("swiper-slider", SwiperSlider);

class FeaturedSwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let s = false;
    t.auto_play > 0 && (s = {
      delay: 1000 * t.auto_play
    });
    let l = false,
      r = false;
    t.loop === "true" || t.loop === true ? l = true : t.loop === 1 ? (l = true, r = true) : (r = false, l = false);
    const o = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: l,
      autoplay: s,
      preventClicks: true,
      preventClicksPropagation: true,
      centeredSlides: r,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        575: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        891: {
          slidesPerView: t.laptop,
          slidesPerColumn: 1
        },
        1200: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      a = new Swiper(n, o);
    a.on("init", () => {
      a.update();
    }), a.init();
  }
}

customElements.define("featured-swiper-slider", FeaturedSwiperSlider);

class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    let e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    let i = $.extend(true, {
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      t = /^\d+$/;
    Object.keys(i).forEach(e2 => {
      typeof i[e2] == "string" && t.test(i[e2]) && (i[e2] = parseInt(i[e2], 10));
    });
    let s = false;
    i.auto_play > 0 && (s = {
      delay: 1000 * i.auto_play
    });
    let l = false,
      o = false;
    i.loop === "true" || i.loop === true ? l = true : i.loop === 1 ? (l = true, o = true) : (o = false, l = false);
    let n = $.extend(true, {
      init: false,
      loop: l,
      autoplay: s,
      centeredSlides: o,
      effect: "coverflow",
      spaceBetween: 0,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 1,
        slideShadows: true
      },
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: i.mobile,
          slidesPerColumn: 1
        },
        560: {
          slidesPerView: i.tablet,
          slidesPerColumn: 1
        },
        768: {
          slidesPerView: i.desktop,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: i.desktop,
          slidesPerColumn: 1
        }
      }
    }, i.options),
      r = this.slider.querySelector("[data-collection-slider]"),
      a = new Swiper(r, n);
    a.on("init", () => {
      a.update();
    }), a.init();
  }
}

customElements.define("collection-slider", CollectionSlider);

class CollectionSwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let l = false;
    t.auto_play > 0 && (l = {
      delay: 1000 * t.auto_play
    });
    let s = false,
      o = false;
    t.loop === "true" || t.loop === true ? s = true : t.loop === 1 ? (s = true, o = true) : (o = false, s = false);
    const r = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: s,
      autoplay: l,
      centeredSlides: o,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        570: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        990: {
          slidesPerView: t.laptop,
          slidesPerColumn: 1
        },
        1280: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      p = new Swiper(n, r);
    p.on("init", () => {
      p.update();
    }), p.init();
  }
}

customElements.define("collection-swiper-slider", CollectionSwiperSlider);

class Accordion {
  constructor(i) {
    this.el = i;
    this.summary = i.querySelector("summary");
    this.content = i.querySelector(".accordion__content");
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", i2 => this.onClick(i2));
  }

  onClick(i) {
    i.preventDefault();
    this.el.style.overflow = "hidden";
    this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink();
  }

  shrink() {
    this.isClosing = true;
    const i = `${this.el.offsetHeight}px`,
      t = `${this.summary.offsetHeight}px`;
    this.animation && this.animation.cancel();
    this.animation = this.el.animate({
      height: [i, t]
    }, {
      duration: 400,
      easing: "ease-out"
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const i = `${this.el.offsetHeight}px`,
      t = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    this.animation && this.animation.cancel();
    this.animation = this.el.animate({
      height: [i, t]
    }, {
      duration: 400,
      easing: "ease-out"
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(i) {
    this.el.open = i;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}

document.querySelectorAll(".dt-details").forEach(i => {
  new Accordion(i);
});

$("#accordian li").click(function() {
  var e = $(this),
    o = e.closest("ul"),
    t = o.find(".active"),
    i = e.closest("li"),
    l = i.hasClass("active"),
    s = 0;
  o.find("ul").slideUp(function() {
    ++s == o.find("ul").length && t.removeClass("active");
  });
  if (!l) {
    i.children("ul").slideDown();
    i.addClass("active");
  }
});

$(window).width() < 767 && ($(".footer_menu").length > 0 && ($(".footer_menu").hide(), $(".footer-links").each(function() {
  $(this).find(".footer__title").click(function() {
    $(this).toggleClass("open");
    $(this).next("ul").slideToggle("slow");
  });
})), $(".footer_newsletter").length > 0 && ($(".footer-block__newsletter").hide(), $(".footer_newsletter").each(function() {
  $(this).find(".footer-block__heading").click(function() {
    $(this).toggleClass("open");
    $(".footer-block__newsletter").slideToggle("slow");
  });
})), $(".footer_address").length > 0 && ($(".footer--address").hide(), $(".footer_address").each(function() {
  $(this).find(".footer-block__heading").click(function() {
    $(this).toggleClass("open");
    $(".footer--address").slideToggle("slow");
  });
})));

class InstaSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    let e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    let i = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      t = /^\d+$/;
    Object.keys(i).forEach(e2 => {
      typeof i[e2] == "string" && t.test(i[e2]) && (i[e2] = parseInt(i[e2], 10));
    });
    let s = false;
    i.auto_play > 0 && (s = {
      delay: 1000 * i.auto_play
    });
    let l = false,
      o = false;
    i.loop === "true" || i.loop === true ? l = true : i.loop === 1 ? (l = true, o = true) : (o = false, l = false);
    let n = $.extend(true, {
      init: false,
      spaceBetween: 0,
      loop: l,
      autoplay: s,
      centeredSlides: o,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      breakpoints: {
        320: {
          slidesPerView: i.mobile,
          slidesPerColumn: 1
        },
        576: {
          slidesPerView: i.tablet,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: i.laptop,
          slidesPerColumn: 1
        },
        1200: {
          slidesPerView: i.desktop,
          slidesPerColumn: 1
        }
      }
    }, i.options),
      r = this.slider.querySelector("[data-insta-slider]"),
      a = new Swiper(r, n);
    a.on("init", () => {
      a.update();
    }), a.init();
  }
}

customElements.define("insta-slider", InstaSlider);

class FlexSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    let e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    let i = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      t = /^\d+$/;
    Object.keys(i).forEach(e2 => {
      typeof i[e2] == "string" && t.test(i[e2]) && (i[e2] = parseInt(i[e2], 10));
    });
    let s = false;
    i.auto_play > 0 && (s = {
      delay: 1000 * i.auto_play
    });
    let l = false,
      o = false;
    i.loop === "true" || i.loop === true ? l = true : i.loop === 1 ? (l = true, o = true) : (o = false, l = false);
    let n = $.extend(true, {
      init: false,
      spaceBetween: 0,
      loop: l,
      autoplay: s,
      centeredSlides: o,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      breakpoints: {
        320: {
          slidesPerView: i.mobile,
          slidesPerColumn: 1
        },
        560: {
          slidesPerView: i.tablet,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: i.desktop,
          slidesPerColumn: 1
        }
      }
    }, i.options),
      r = this.slider.querySelector("[data-flex-slider]"),
      a = new Swiper(r, n);
    a.on("init", () => {
      a.update();
    }), a.init();
  }
}

customElements.define("flex-slider", FlexSlider);

class RecommendationSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let s = false;
    t.auto_play > 0 && (s = {
      delay: 1000 * t.auto_play
    });
    let l = false,
      r = false;
    t.loop === "true" || t.loop === true ? l = true : t.loop === 1 ? (l = true, r = true) : (r = false, l = false);
    const o = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: l,
      autoplay: s,
      preventClicks: true,
      preventClicksPropagation: true,
      centeredSlides: r,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        576: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        990: {
          slidesPerView: t.laptop,
          slidesPerColumn: 1
        },
        1541: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      a = new Swiper(n, o);
    a.on("init", () => {
      a.update();
    });
    a.init();
  }
}

customElements.define("recommendation-slider", RecommendationSlider);

class MultiSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let s = false;
    t.auto_play > 0 && (s = {
      delay: 1000 * t.auto_play
    });
    let l = false,
      r = false;
    t.loop === "true" || t.loop === true ? l = true : t.loop === 1 ? (l = true, r = true) : (r = false, l = false);
    const o = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: l,
      preventClicks: true,
      preventClicksPropagation: true,
      autoplay: s,
      centeredSlides: r,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        560: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: t.laptop,
          slidesPerColumn: 1
        },
        1200: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      a = new Swiper(n, o);
    a.on("init", () => {
      a.update();
    });
    a.init();
  }
}

customElements.define("multi-slider", MultiSlider);

class BlogSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let s = false;
    t.auto_play > 0 && (s = {
      delay: 1000 * t.auto_play
    });
    let l = false,
      r = false;
    t.loop === "true" || t.loop === true ? l = true : t.loop === 1 ? (l = true, r = true) : (r = false, l = false);
    const o = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: l,
      preventClicks: true,
      preventClicksPropagation: true,
      autoplay: s,
      centeredSlides: r,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        560: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: t.laptop,
          slidesPerColumn: 1
        },
        1200: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      a = new Swiper(n, o);
    a.on("init", () => {
      a.update();
    });
    a.init();
  }
}

customElements.define("blog-slider", BlogSlider);

class SupportSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let s = false;
    t.auto_play > 0 && (s = {
      delay: 1000 * t.auto_play
    });
    let l = false,
      r = false;
    t.loop === "true" || t.loop === true ? l = true : t.loop === 1 ? (l = true, r = true) : (r = false, l = false);
    const o = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: l,
      preventClicks: true,
      preventClicksPropagation: true,
      autoplay: s,
      centeredSlides: r,
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      focusableElements: "input, select, option, textarea, video, label",
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        560: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: t.laptop,
          slidesPerColumn: 1
        },
        1200: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      a = new Swiper(n, o);
    a.on("init", () => {
      a.update();
    });
    a.init();
  }
}

customElements.define("support-slider", SupportSlider);

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    entry.isIntersecting ? entry.target.classList.add("reveal") : entry.target.classList.remove("reveal");
  });
}),
  hiddenElements = document.querySelectorAll(".shopify-section");
hiddenElements.forEach(el => observer.observe(el));

class TopSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[data-slider-options]");
    this.init();
  }

  init() {
    const e = this.slider.getAttribute("data-slider-options");
    if (e === null || e === "") return null;
    const t = $.extend(true, {
      effect: "slide",
      direction: "horizontal",
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {}
    }, JSON.parse(e)),
      i = /^\d+$/;
    Object.keys(t).forEach(e2 => {
      typeof t[e2] == "string" && i.test(t[e2]) && (t[e2] = parseInt(t[e2], 10));
    });
    let s = false;
    t.auto_play > 0 && (s = {
      delay: 5000 * t.auto_play
    });
    let l = false,
      r = false;
    t.loop === "true" || t.loop === true ? l = true : t.loop === 1 ? (l = true, r = true) : (r = false, l = false);
    const o = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop: l,
      autoplay: s,
      centeredSlides: r,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: this.slider.querySelector(".swiper-button-next"),
        prevEl: this.slider.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true
      },
      lazy: true,
      breakpoints: {
        320: {
          slidesPerView: t.mobile,
          slidesPerColumn: 1
        },
        560: {
          slidesPerView: t.tablet,
          slidesPerColumn: 1
        },
        992: {
          slidesPerView: t.desktop,
          slidesPerColumn: 1
        }
      }
    }, t.options),
      n = this.slider.querySelector("[data-swiper-slider]"),
      a = new Swiper(n, o);
    a.on("init", () => {
      a.update();
    });
    a.init();
  }
}

customElements.define("top-bar-slider", TopSlider);

//# sourceMappingURL=/s/files/1/0659/9953/6387/t/15/assets/global.js.map?v=1700705960
